import { isNil, omitBy } from 'lodash';
import { generatePath } from 'react-router-dom';

/** '/a' + 'b' → '/a/b' */
export const join = (...parts: Array<string | undefined>): string => {
  return parts
    .filter(Boolean)
    .join('/')
    .replace(/\/{2,}/g, '/'); // remove duplicate slashes, just in case
};

/** root + pattern (+ params) → absolute URL */
export const absolute = (
  root: string,
  pattern: string,
  params?: Record<string, string | undefined>
): string => {
  return generatePath(join(root, pattern), omitBy(params, isNil));
};
